export const openInbox = () => console.log('openInbox web') // eslint-disable-line no-console
export const openComposer = () => console.log('openComposer web') // eslint-disable-line no-console
